// import Vue from 'Vue'
import wx from 'weixin-js-sdk'
// import store from '../store'
// import Vue from 'vue'
// 获取cookie、
// export function getCookie (name) {
//   var arr = []
//   let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
//   if (arr = document.cookie.match(reg)) { return (arr[2]) } else { return null }
// }

// // 设置cookie,增加到vue实例方便全局调用
// export function setCookie (c_name, value, expiredays) {
//   let exdate = new Date()
//   exdate.setDate(exdate.getDate() + expiredays)
//   document.cookie = c_name + '=' + escape(value) + ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
// };

// // 删除cookie
// export function delCookie (name) {
//   let exp = new Date()
//   exp.setTime(exp.getTime() - 1)
//   let cval = getCookie(name)
//   if (cval != null) { document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString() }
// };
// 判断环境
var ua = window.navigator.userAgent.toLowerCase()
// if (ua.match(/MicroMessenger/i) === 'micromessenger') { // 判断是否是微信环境
// 微信环境
if (ua.indexOf('micromessenger') > -1) {
  wx.miniProgram.getEnv(function (res) {
    console.log(res, '判断环境')
    if (res.miniprogram) {
      // 小程序环境下逻辑
      localStorage.setItem('isMp', 'yes')
      console.log('我在小程序里')
    } else {
      // 非小程序环境下逻辑
      console.log('我在微信里但是我不是小程序')
      localStorage.setItem('isMp', 'noIsWxH5')
    }
  })
} else {
  console.log('我不在微信里')
  localStorage.setItem('isMp', 'noIsWebH5')
  // 非微信环境逻辑
}

export const isWeixin = (function(){
  var ua = navigator.userAgent.toLowerCase();
  if(ua.match(/MicroMessenger/i)=='micromessenger') {
    return true
  }
  else{
    return false
  }
})()

export function isMiniProgamme() {

  const ua = window.navigator.userAgent.toLowerCase()
  return new Promise((resolve) => {
    if (ua.indexOf('micromessenger') == -1) {//不在微信或者小程序中
      resolve(false)
    } else {
      wx.miniProgram.getEnv((res) => {
        //alert(res.miniprogram)
        if (res.miniprogram) {//在小程序中
          resolve(true)
        } else {//在微信中
          resolve(false)
        }
      })
    }
  })
}

export function miniProgNavigateTo(url) {
  wx.miniprogram.navigateTo({url})
}




// WEBPACK FOOTER //
// ./src/common/util.js